import {extendObservable, observable, computed, autorun} from 'mobx';
import axios from '../../../libs/axios_csrf';
import {BMC_BLOCKS, BMC_STAGES} from '../../common_components/bmc/bmc_constants';
import {isValidBlock, blocksArray, initFiltersFromBmcStages} from '../../common_components/bmc/bmc_functions';
import {BOARD_TYPES, TEMPLATES, LEAN_BLOCKS} from "../constants";
import {isValidBoardType, boardTypesArray, isLeanBlock} from "../functions";
import BlockStore from "../../bmc_components/stores/BlockStore";
import BmcCard from "../../bmc_components/stores/BmcCard";
import AttachmentsStore from "../../common_components/attachments/stores/Attachments";

export default class IgBusinessStore{

  constructor(rootStore, authorizationStore){
    this.rootStore = rootStore;
    this.authorizationStore = authorizationStore;
    this.attachmentsStore = new AttachmentsStore();

    let blockNames = blocksArray();
    let lastSelectedCard = {};
    for( let blockName of blockNames){ 
      lastSelectedCard[blockName] = undefined;
    }
    let blocks = {}
    blocks[BOARD_TYPES.CURRENT_BMC] = [];
    blocks[BOARD_TYPES.VISION] = [];
    extendObservable(this, {
      blocks: blocks,
      currentBlock: BMC_BLOCKS.REVENUE_STREAMS,
      lastSelectedCard: lastSelectedCard,
      defaultFormDetails: "",
      currentBoard: BOARD_TYPES.CURRENT_BMC,
      boardsLoading: false,
      currentStage: BMC_STAGES.OBSERVATIONAL,
      filters: initFiltersFromBmcStages()
    });
    this.boardId = {};
    this.boardId[BOARD_TYPES.CURRENT_BMC] = null;
    this.boardId[BOARD_TYPES.VISION] = null;
    this.isIgMeasure = true;
  }

  initStore(visionBoardId, currentBoardId){
    this.boardsLoading = true;
    this.boardId[BOARD_TYPES.CURRENT_BMC] = currentBoardId;
    this.boardId[BOARD_TYPES.VISION] = visionBoardId;
    let boardTypes = boardTypesArray();
    for( let i=0; i < boardTypes.length; i++ ){
      const allBoardsLoaded = (i == (boardTypes.length - 1));
      this.fetchLists(boardTypes[i], allBoardsLoaded );
    }
  }


  /////////////// ADDITIONAL FUNCTIONS TO MAKE THE BLOCKSTORE WORK /////////////////
  isCurrentStageFree() {
      // BMC VISION can be disabled from here too.
      return this.currentStage === BMC_STAGES.FREE;
  }
  showLabelForm(label) {
      return this.isCurrentStageFree() && !Object.values(BMC_STAGES).includes(label)
  }

  @computed get isBmcVision(){
    return this.currentBoard == BOARD_TYPES.VISION;
  }
  ////////////////////////////////////////////////////////////////////////////////////

  @computed get currentBlockStore(){
    if( isValidBlock(this.currentBlock) ){
      return this.getBlockStoreByName(this.currentBlock); 
    }
    return null;
  }

  getBlockStoreByName(name) {
    return this.blocks[this.currentBoard].find(b => b.name === name)
  }
  ///////////// GETTERS AND SETTERS ///////////

  resetCardSelection(){
    let cards = this.allCards;
    for( let card of cards){
      card.selected = false;
    }
  }

  setLastSelectedCard(block, card){
    if( isValidBlock(block) ){
      this.lastSelectedCard[block] = card;
    }
  }

  getCurrentBlock(){
    return this.currentBlock;
  }

  setCurrentBlock(block){ 
    this.currentBlock = block;
  }

  getCurrentBoardCardsByBlock(blockName){
    return this.getCardsByBlockAndBoardType(blockName, this.currentBoard);
  }

  getCardsByBlockAndBoardType(blockName, boardType){
    if( isValidBoardType(boardType) ){
      if(isValidBlock(blockName)){
        let block = this.blocks[boardType].find((el) => el.name == blockName );
        return block ? block.filteredCards() : [];
      }
    }
    return [];
  }

  getCardsByBlock(blockName){
    if(isValidBlock(blockName)){
      let boardTypes = boardTypesArray();
      let cards = []
      for( let type of boardType ){
        let block = this.block[type].find((el) => el.name == blockName );
        let blockCards = block ? block.cards : [];
        cards =  [... cards, ...blockCards];
      }
      return cards;
    }
    return [];
  }

  getSelectedCardsByBlock(block){
    let cards = this.getCardsByBlock(block).filter( (c) => c.selected );
    return cards;
  }

  @computed get currentBlockSelectedCards(){
    return this.currentBlockCards.filter( (el) => el.selected == true )
  }

  @computed get currentBlockCards(){
    return this.getCardsByBlock(this.currentBlock);
  }


  @computed get selectedCards(){
    return this.allCards.filter( (el) => ( el.selected == true ) );
  }

  @computed get allCards(){
    let cards = [];
    let boardTypes = boardTypesArray();
    for( let type of boardTypes ){
      for( let block of this.blocks[type]  ){
        // Concatenate
        cards = [... cards, ... block.cards];
      }
    }
    return cards;
  }

  setCurrentBoard(boardType){
    if( boardTypesArray().includes(boardType) ){
      this.currentBoard = boardType;
    }
  }

  setCurrentStage(stage){
    if( Object.keys(BMC_STAGES).map((key) => BMC_STAGES[key]).includes(stage) ){
      this.currentStage = stage;
    }
  }

  getBlock(blockName){
    return this.currentBoardBlocks.find( (b) => b.name == blockName)
  }

  setSelectedActivityCard(c){
    let cards = this.getCardsByBlock(BMC_BLOCKS.KEY_ACTIVITIES);
    for( let card of cards ){
      if( card == c ){
        card.selected = true;
        card.preselected = false;
      }
      else{
        card.selected = false;
      }
    }
  }

  getCardsFromIdsArray(ids){
    ids = ids.map((el) => parseInt(el));
    let cards = this.allCards.filter( (el) => ids.includes(el.id) );
    return cards;
  }


  @computed get currentBlockLastSeletedCard(){
    return this.lastSelectedCard[this.currentBlock];
  }


  generateAlert(alert){
    return null;
  }

  applyTemplate(template, intl){
    let blocksInfo = template.blocksInfo;

    for( const [blockName, templateBlockInfo] of Object.entries(blocksInfo) ){
      const block = this.getBlockStoreByName(blockName);
      // Block is from BMC
      if( isValidBlock(blockName) ){
        this.addBmcBlockTemplateCards(block, templateBlockInfo, intl);
      }
      // Block is lean
      else if( isLeanBlock(blockName) ){
        this.addLeanBlockTemplateCards(blockName, templateBlockInfo, intl)
      }

    }
  }

  addBmcBlockTemplateCards(block, templateBlockInfo, intl){
    if( templateBlockInfo.automatic ){
      for( const card of block.cards ){
            this.rootStore.activityStore.activityEdit.addCard(card, block.name);
            card.selected = true;
          }
      }
    else{
      for( const card of templateBlockInfo.cards ){
        let newCard = new BmcCard( block , {
            name: intl.formatMessage({id: card.name }),
            description: intl.formatMessage({id: card.description}) },
            false
        );


        block.addTemplateCards(newCard).then( (newCard) => {
          this.rootStore.activityStore.activityEdit.addCard(newCard, block.name);
          newCard.selected = true;
        });
      }
    }
  }

  addLeanBlockTemplateCards(block, templateBlockInfo, intl){
    for( let card of templateBlockInfo.cards ){
      this.rootStore.activityStore.activityEdit.addLeanDetails(block, intl.formatMessage({id: card.description}));
    }
  }


  ////// BACKEND CONNECTION /////////////
  fetchLists(boardType, allBoardsLoaded){
    axios.get('/bmc_boards/' + this.boardId[boardType] + '.json')
      .then((response) => {

          this.setCurrentStage(response.data.boardPreference.currentStage);

          response.data.blocks.forEach((block) => {
              this.blocks[boardType].push(new BlockStore(this, block))
          });

          if( boardType == BOARD_TYPES.CURRENT_BMC ){
            let boardPreference = response.data.boardPreference; 
            this.currentStage = boardPreference.currentStage;
          }

          if( allBoardsLoaded ){
            this.boardsLoading = false;
          } 
      })
      .catch((thrown) => {
          if (axios.isCancel(thrown)) {
              console.log('Request canceled', thrown.message);
          } else {
              console.log(thrown);
          }
      });
  }
}